module.exports = __webpack_public_path__ + "static/media/organizationdetails-banner.8f3cca10.svg";